<template>
    <div class="w-full rounded overflow-hidden shadow-lg ">
      <div class="p-2 flex flex-col-2">
        <p v-if="step === 0"> 
          Para continuar, por favor complete los siguientes campos con su información
        </p>
        <p v-if="step !== 0"> 
          Ingresa los datos de tu perfil, para mantener tu contcto actualizado.
        </p>
      </div>
      
      <div class="p-2 flex flex-col-2">
        <div class="flex flex-1 justify-center items-center mt-5 p-2">
          <fwb-input
            v-model="name"
            label="Nombre"
            placeholder="Ingresa tu nombre"
            size="sm"
            class="w-full"
          />
        </div>
  
        <div class="flex flex-1 justify-center items-center mt-5 p-2">
          <div 
            placeholder="Ingresa tu apellido materno" 
            class="w-full"
          >
            <label
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Fecha de nacimiento
            </label>
            <div class="flex relative">
              <VueDatePicker
                v-model="birthday"
                class=""
                :format="format"
                :locale="es" 
              />
            </div>
          </div>
        </div>
      </div>
  
      <div class="p-2 flex flex-col-2">
        <div class="flex flex-1 justify-center items-center mt-5 p-2">
          <fwb-input
            v-model="last_name"
            label="Apellido paterno"
            placeholder="Ingresa tu apellido paterno"
            size="sm"
            class="w-full"
          />
        </div>
        <div class="flex flex-1 justify-center items-center mt-5 p-2">
          <fwb-input
            v-model="last_second_name"
            label="Apellido materno"
            placeholder="Ingresa tu apellido materno"
            size="sm"
            class="w-full"
          />
        </div>
      </div>
  
      <div class="p-2 flex flex-col-2">
        <div class="flex flex-1 justify-center items-center mt-5 p-2">
          <fwb-input
            v-model="email"
            required
            placeholder="Ingresa tu email"
            label="Email"
            class="w-full"
          />
        </div>
  
        <div class="flex flex-1 justify-center items-center mt-5 p-2">
          <fwb-input
            v-model="phone"
            required
            placeholder="Ingresa tu teléfono"
            label="Teléfono"
            class="w-full"
          />
        </div>
      </div>
  
      <div class="p-2 flex flex-col">
        <div class="flex flex-1 justify-center items-center mt-5 p-2">
          <fwb-textarea
            v-model="aboute_me"
            :rows="4"
            :cols="100"
            label="Sobre mí"
            placeholder="Escríbe una descripción sobre ti para que te conozcan más tus prospectos "
            class="w-full"
          />
        </div>
      </div>
  
      <div class="p-2 flex flex-col">
        <div class="flex flex-1 justify-end items-end mt-5 p-2">
          <fwb-button 
            class="bg-tuin-100 hover:bg-tuin-100" 
            size="xl"
            @click="saveData()"
          >
            Guardar
          </fwb-button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { FwbInput, FwbTextarea, FwbButton } from "flowbite-vue";
  import { ref, computed, onMounted } from "vue";
  import { es } from 'date-fns/locale';
  import VueDatePicker from "@vuepic/vue-datepicker";
  import axios from "axios";
  
  // LLamar a la sesion
  import { useStore } from 'vuex';
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  import { useRouter } from "vue-router";
  let router = useRouter();
  
  let name = ref(null);
  let birthday = ref();
  let email = ref();
  let aboute_me = ref();
  let phone = ref();
  let last_name = ref();
  let last_second_name = ref();
  let step = ref(1);
  let profile = ref();
  let toastAlert  = ref(false);
  let typeMsg     = ref("");
  let msg         = ref("");
  
  const format = (birthday) => {
    const day = birthday.getDate();
    const month = birthday.getMonth() + 1;
    const year = birthday.getFullYear();
  
    return `${day}/${month}/${year}`;
  };
  
  async function getProfile(){
      try {
          let options = {
              headers: {
                  'Authorization': `Bearer ${session.value.token_api}`
              }
          }
  
          const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,options
          );
  
          if (response.status == 401) {
              store.dispatch('clearUserSession');
          }
  
          if (response.status == 200) {
              
              profile.value               = response.data.resp.info;
              name.value                  = response.data.resp.info.name;
              last_name.value             = response.data.resp.info.last_name;
              last_second_name.value      = response.data.resp.info.last_second_name;
              email.value                 = response.data.resp.info.email;
              phone.value                 = response.data.resp.info.phone;
              aboute_me.value             = response.data.resp.info.about_me;
              birthday.value              = response.data.resp.info.birthday;
              
              
              
          // filteredProperties.value = response.data.resp;
          }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
  }
  
  async function saveData(){
  
    if(session.value.step < 3){
      step.value              = 1; 
    }else{
      step.value              = session.value.step; 
    }
    const formattedBirthday = birthday.value ? 
    new Date(birthday.value).toLocaleDateString('en-CA') : '';  // formato 'YYYY-MM-DD'
    let params = {
      'name'              : name.value, 
      'birthday'          : formattedBirthday,
      'email'             : email.value,
      'aboute_me'         : aboute_me.value,
      'phone'             : phone.value,
      'last_name'         : last_name.value,
      'last_second_name'  : last_second_name.value,
      'step'              : step.value,
      'source'            : 'broker'
    }
  
    try {
      let options = {
            headers: {
                'Authorization': `Bearer ${session.value.token_api}`
            }
      }
  
      const response = await axios.put(
          `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/update-general`,
          params,
          options        
      );
  
      if (response.status == 200) {
        showToast('success', 'Datos guardados correctamente')
        console.log(session.value)
        if(session.value.step < 3 ){
          session.value.step=1;
          router.push({ name: "info_company" });
        }
      }
  
    } catch (error) {
          console.error("Error fetching data:", error);
    }
  }
  
  async function showToast( type = null, message = null){
    toastAlert.value  = true;
    typeMsg.value     = type;
    msg.value         = message;
  
    setTimeout(() => {
      closeToast();
    }, 3000);
  }
  
  async function closeToast() {
    toastAlert.value = false;
    typeMsg.value = "";
    msg.value = "";
  }
  
  onMounted(async () => {
    try {
      getProfile();
      step.value = session.value.step;
    } catch (error) {
      console.error('Error al intentar traer los datos', error);
    }
  });
  
  </script>
  <style scoped>
    /* Si el label tiene clases predeterminadas de Flowbite/Tailwind, puedes sobrescribirlas */
    ::v-deep .custom-label label {
      @apply text-white;
    }
  
    /* También puedes apuntar directamente al selector completo */
    ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
      @apply text-white;
    }
    body{
      background-color: #ffffff !important;
    }
  </style>
  